import {
  GridFilterInputValueProps,
  GridFilterItem,
  GridFilterOperator,
  TextField,
} from "@platform/style";
import * as React from "react";

export const CustomFreeFormOperators: GridFilterOperator<any, string>[] = [
  {
    label: "contains",
    value: "contains",
    getApplyFilterFn: (filterItem) => {
      return applyFilterFn(filterItem);
    },
    InputComponent: InputTextValue,
    InputComponentProps: { type: "string" },
    getValueAsString: (value: string) => `${value}`,
  },
  {
    label: "equals",
    value: "equals",
    getApplyFilterFn: (filterItem) => {
      return applyFilterFn(filterItem);
    },
    InputComponent: InputTextValue,
    InputComponentProps: { type: "string" },
    getValueAsString: (value: string) => `${value}`,
  },
];

function applyFilterFn(filterItem: GridFilterItem) {
  if (!filterItem.field || !filterItem.value || !filterItem.operator) {
    return null;
  }

  return (params: any): boolean => {
    return String(params.value) >= String(filterItem.value);
  };
}

function InputTextValue(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const [textValue, setTextValue] = React.useState<string>("");

  return (
    <TextField
      value={item.value ? item.value : textValue}
      variant={"standard"}
      sx={{ marginTop: "6px", padding: "11px", width: "100%" }}
      placeholder={item.field == "AssignedTo" ? "Search by first or last name" : "Filter value"}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        setTextValue(event.target.value);
      }}
      onFocus={() => (item.value = "")}
      onBlur={(event) => applyValue({ ...item, value: event.target.value })}
    ></TextField>
  );
}
